import React from 'react';
import { useAuthContext } from '../../context/AuthContext';
import { usePageTitle } from '../../hooks/usePageTitle';

const Messages: React.FC = () => {
  usePageTitle('Messages | From the Pitchside');

  const { user } = useAuthContext();

  return (
    <div className="text-darkblue">
        <h2>Messages</h2>
    </div>
  );
};

export default Messages;
